import { Component, Input, OnInit } from '@angular/core';

import { Queue, Faculty } from '../../../../models';
import { QueueService } from '../../../../services';

@Component({
    selector: 'qms-queues-tree-view-item',
    templateUrl: './queues-tree-view-item.component.html',
    styleUrls: ['queues-tree-view-item.component.css']
})
export class QueuesTreeViewItemComponent implements OnInit {
    @Input()
    public queue: Queue;

    @Input()
    public parent: Queue;

    @Input()
    public faculty: Faculty;

    public children: Queue[];

    constructor(private queueService: QueueService) {
    }

    ngOnInit() {
        if (!this.queue) {
            return;
        }

        this.queueService.findChildren(this.queue.id).subscribe((children: Queue[]) => {
            this.children = children;
        });
    }

    public getQueryParams(): any {
        if (this.parent) {
            return { parentId: String(this.parent.id) };
        }
        return '';
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/management/queues/tree-view/queues-tree-view-item.component.ts